import { ProductParagraph, sizeLineHeightParagraphStepNegative2 } from '@issuu/silkscreen';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { maxSize } from '../../util/ads-utils';
import DocumentContext from '../DocumentPage/DocumentContext';
import { GoogleAdsTemplate } from './GoogleAdsTemplate';

const Root = styled.div<{ width: number; height: number }>`
    width: ${props => props.width}px;
    height: calc(${props => props.height}px + ${sizeLineHeightParagraphStepNegative2});
`;

export const AdsDocumentDetail: React.FC = () => {
    const {
        publisher: {
            licenses: { docpageAds },
        },
        appState: {
            currentLayout: { name: layout },
        },
    } = useContext(DocumentContext);
    const network = docpageAds
        ? '/30443627/DocPage_DocInfo_adConnect'
        : '/30443627/DocPage_DocInfo';

    const adSizes =
        docpageAds || layout === 'tiny'
            ? [[300, 250]]
            : [
                  [400, 300],
                  [300, 250],
              ];
    const [width, height] = maxSize(adSizes);
    return (
        <Root height={height} width={width}>
            <GoogleAdsTemplate adSizes={adSizes} idSuffix="documentDetail" network={network} />
            <ProductParagraph step="negative-2">Advertisement</ProductParagraph>
        </Root>
    );
};
